const debug = false;

const AppConfig = {
  app_name: "LaddarOS",
  business_name: "Laddar Africa",
  business_website: "https://laddar.africa",
  tag_line: "Business tools for African markets",
  api_base_url: debug ? "http://127.0.0.1:8000/v1/" : "https://api.laddar.africa/v1/",
  api_media_url: debug ? "http://127.0.0.1:8000/media/" : "https://api.laddar.africa/media/",
  // api_base_url: "http://127.0.0.1:8000/v1/",
  // api_media_url: "http://127.0.0.1:8000/media/",
  auth_token: "_ldr_portal_auth_token",
  app_version_store: "_ldr_portal_version_",
  sidenav_active_menu_color: "info",
  messageDialogShown: false,
  dashboard: "SALES",
  google_map_key: "AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0",
  calendly_link: "https://calendly.com/shalewa-kasali-laddar/30min"
};

export default AppConfig;
